import React from "react";

export function ChevronLeftIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="icon"
      viewBox="0 0 16 16"
      style={{ width: 12 }}
    >
      <path
        fillRule="evenodd"
        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
      />
    </svg>
  );
}

export function ChevronRightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="icon"
      viewBox="0 0 16 16"
      style={{ width: 12 }}
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );
}

export function CheckIcon(props: { className?: string }) {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon ${props.className}`}
    >
      <path
        d="M14.8525 0.14822C14.8973 0.19731 14.9334 0.256205 14.9587 0.321539C14.984 0.386874 14.9979 0.457367 14.9998 0.528992C15.0017 0.600617 14.9914 0.671969 14.9696 0.738971C14.9478 0.805973 14.9148 0.867313 14.8726 0.919484L5.83241 11.8284C5.74837 11.9324 5.63269 11.9938 5.51019 11.9996C5.3877 12.0053 5.26813 11.955 5.17716 11.8593L0.160039 6.37778C0.113272 6.33015 0.0751121 6.27216 0.047781 6.20719C0.0204499 6.14222 0.00449357 6.07157 0.00084074 5.99936C-0.00281209 5.92715 0.0059115 5.85481 0.0265039 5.78656C0.0470962 5.7183 0.0791461 5.6555 0.120787 5.60181C0.162429 5.54811 0.21283 5.50459 0.269057 5.47378C0.325284 5.44298 0.386214 5.4255 0.448299 5.42236C0.510384 5.41923 0.572385 5.4305 0.630693 5.45552C0.689 5.48055 0.742449 5.51882 0.787928 5.56812L5.4643 10.6918L14.1901 0.171674C14.2323 0.119505 14.2828 0.0775153 14.3389 0.0481025C14.3951 0.0186897 14.4556 0.00243014 14.5171 0.000252191C14.5786 -0.00192576 14.6399 0.0100206 14.6974 0.0354091C14.755 0.0607975 14.8076 0.0991305 14.8525 0.14822Z"
        fill="currentColor"
      />
    </svg>
  );
}
